export default __webpack_public_path__ + "static/media/home-slider-55.577033fd.jpg";